import './resizeHandler';

import touchevents from './detectTouch';

window.V_HEIGHT = Math.max(window.innerWidth, window.innerHeight);

export const HTML = document.documentElement;
export const BODY = document.body;
export const BREAKPOINTS = {
	xs: 320,
	sm: 650,
	md: 712,
	lg: 1024,
	laptop: 1280,
	xl: 1366,
	'2xl': 1440,
	'3xl': 1600,
	'f-hd': 1920,
	'2k': 2048,
	tablet: 899,
};

/*
  Breakpoints utility function
  @params: point - {number} - breakpoint to check, e.g. BREAKPOINTS.tablet
  @params: desktopFirst - {boolean} - if you need desktop first

  @return: boolean

  Usage

  import 2 itilities
  import {BREAKPOINTS, breakpoint} from 'Utils/global';

  window.addEventListener('resize', () => {
    if (breakpoint(BREAKPOINTS.desktop)) {
      console.log('IS DESKTOP')
    } else {
      console.log('IS MOBILE')
    }
  })
*/
export const breakpoint = (point, desktopFirst = false) => {
	if (desktopFirst) {
		return window.innerWidth < point;
	}

	return window.innerWidth >= point;
};

export const isPortrait = () => {
	const { innerWidth, innerHeight } = window;
	return innerHeight > innerWidth;
};

/*
  Detect touchevents
  @params: {obj} - window
  @return: boolean
*/
export const isTouch = (obj = window) => touchevents(obj);

export const MOBILE_LOOK =
	(isTouch() &&
		((isPortrait() && breakpoint(BREAKPOINTS.xl)) || (!isPortrait() && breakpoint(BREAKPOINTS.laptop)))) ||
	breakpoint(BREAKPOINTS.laptop, true);

export const isTablet = breakpoint(BREAKPOINTS.tablet, true);
export const isMobile = breakpoint(BREAKPOINTS.md, true);
// export const isMobile = breakpoint(BREAKPOINTS.tablet, true);
/*
  "jQuery like" ready function:
  Usage:

  import ready from 'Utils/global';
  ready(() => init());
*/

export default Document.prototype.ready = (fn) => {
	if (fn && typeof fn === 'function') {
		document.addEventListener('DOMContentLoaded', () => {
			if (document.readyState === 'interactive' || document.readyState === 'complete') {
				return fn();
			}
		});
	}
};

/*
  Publish custom event
  Params:

  {eventName}: String - the name of custom event. Better to use as a variable or constant not to mess names
  {data}: Object - custom event information, e.g. node element, whatever. Accessible via event
  {once}: Bool - trigger only once or every time when called
  Exmaple:

  import {ev} from 'Utils/global';

  const eventName = 'PopupToggle';

  popup.on('click', () => {
    ev(eventName, {
      popup: this,
    })
  })

  document.addEventListener(eventName, event => {
    // this is data that we pass into custom event
    const eventData = event.detail;
    const popupInstance = eventData.popup;
  })
*/

export const ev = (eventName, data, target = document) => {
	const e = new CustomEvent(eventName, { detail: data });
	target.dispatchEvent(e);
};

/* @return boolean (true=IE) */
export const isIE = () => {
	return /*@cc_on!@*/ false || !!document.documentMode;
};

export const getMousePos = (event) => {
	let e = event;
	let posx = 0;
	let posy = 0;
	if (!e) e = window.event;
	if (e.pageX || e.pageY) {
		posx = e.pageX;
		posy = e.pageY;
	} else if (e.clientX || e.clientY) {
		posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
		posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
	}

	return { x: posx, y: posy };
};

export const MathUtils = {
	// linear interpolation
	lerp: (a, b, n) => (1 - n) * a + n * b,
	// distance between two points
	distance: (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1),
	map: (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c,
	getRandomNumber: (min, max) => Math.floor(Math.random() * (max - min + 1) + min),
};

export const calcWinsize = () => {
	return { width: window.innerWidth, height: window.innerHeight };
};

export const easeOutSine = (t, b, c, d) => c * Math.sin((t / d) * (Math.PI / 2)) + b;

export const easeOutQuad = (t, b, c, d) => {
	// eslint-disable-next-line no-param-reassign
	t /= d;
	return -c * t * (t - 2) + b;
};

export const GOLD_BAR = document.getElementById('cnn-bar');
export const ASSETS_PATH = 'https://cnnadfeature.imfast.io/porsche/2021/better-tech-for-all/images/';

export const GLOBAL = {
	name: 'GLOBAL',
	muted: 'muted',
	introPassed: 'introPassed',
	preIntroPassed: 'preIntroPassed',
	customHeader: 'customHeader',
	audioPlaying: 'audioPlaying',
};

export const CAROUSEL = {
	next: 'CAROUSEL.next',
	prev: 'CAROUSEL.prev',
};

export const AJAX = {
	reset: 'Ajax.reset',
	initBase: 'Ajax.initBase',
	in: {
		start: 'AjaxInStart',
		end: 'AjaxInEnd',
	},
	out: {
		start: 'AjaxOutStart',
		end: 'AjaxOutEnd',
	},
};

const SCROLL_API = '.LocomotiveScroll';
export const SCROLL = {
	namespace: SCROLL_API,
	ready: `ready${SCROLL_API}`,
	scrolling: `scrolling${SCROLL_API}`,
	update: `update${SCROLL_API}`,
	destroy: `destroy${SCROLL_API}`,
	stop: `stop${SCROLL_API}`,
	play: `play${SCROLL_API}`,
	call: `call${SCROLL_API}`,
	scrollTo: `scrollTo${SCROLL_API}`,
};

export const POPUP = {
	opened: 'POPUP.opened',
	closed: 'POPUP.closed',
	update: 'POPUP.update',
};

export const LOAD_MORE = {
	loaded: 'LOAD_MORE.loaded',
};

export const MAGNET = {
	enter: 'MAGNET.enter',
	leave: 'MAGNET.leave',
	update: 'MAGNET.update',
};

export const CURSOR = {
	move: 'CURSOR.move',
};

export const PRELOADER = {
	done: 'PRELOADER.done',
	storageID: 'PRELOADER_PASSED',
};

export const LAZYLOAD = {
	update: 'LAZYLOAD.update',
};

export const SELECT = {
	update: 'SELECT.update',
};

export const RANGE = {
	update: 'RANGE.update',
	event: {
		onSlideStart: 'RANGE.event.onSlideStart',
		onSlide: 'RANGE.event.onSlide',
		onSlideEnd: 'RANGE.event.onSlideEnd',
	},
	value: {
		set: 'RANGE.value.set',
	},
};

export const PROGRESS = {
	set: 'PROGRESS.set',
	hide: 'PROGRESS.hide',
	hideFull: 'PROGRESS.hideFull',
	show: 'PROGRESS.show',
	showFull: 'PROGRESS.showFull',
	animate: 'PROGRESS.animate',
	lastPassed: 'PROGRESS.lastPassed',
};

export const SHOW_MORE = {
	update: 'SHOW_MORE.update',
};

export const ACCORDION = {
	change: 'ACCORDION.change',
};

export const VIDEO = {
	playing: 'VIDEO.playing',
	paused: 'VIDEO.paused',
	leave: 'VIDEO.leave',
	enter: 'VIDEO.enter',
};

export const NAV = {
	active: 'NAV_ACTIVE',
	innactive: 'NAV_INNACTIVE',
};

export const getDimension = () => (isTouch() ? 'px' : '%');

export const END_DYNAMIC = (value, viewport) => (isTouch() ? (viewport * value) / 100 : value);

export const { V_HEIGHT } = window || window.innerHeight;

(function (mouseStopDelay) {
	let timeout;
	document.addEventListener('mousemove', function (e) {
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			const event = new CustomEvent('mousestop', {
				detail: {
					clientX: e.clientX,
					clientY: e.clientY,
				},
				bubbles: true,
				cancelable: true,
			});
			e.target.dispatchEvent(event);
		}, mouseStopDelay);
	});
})(1000);

export const getClosestBreakpoint = (goal, variants) =>
	variants.reduce((prev, curr) => (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev));
